export default {
    SOFTWARES: 'Softwares',
    DIREITOS_AUTORAIS: 'Direitos Autorais',
    LICENCAS: 'Licenças',
    MARCAS_E_PATENTES: 'Marcas e Patentes',
    TITULOS_DE_PUBLICACAO: 'Titulos de Publicação',
    RECEITAS_FORMULAS_E_PROJETOS: 'Receitas, Fórmulas e Projetos',
    DIREITOS_DE_USO: 'Direitos de Uso'
}
